import axios from 'axios';
import { message } from 'antd';

// Use current origin to ensure HTTPS
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || window.location.origin;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  timeout: 30000
});

console.log('API Base URL:', api.defaults.baseURL);

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    if (!config.url.includes('/refresh-token')) {
      console.log(`[API] Request to ${config.method?.toUpperCase()} ${config.url}`);
    }

    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('[API] Request setup failed:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    if (!response.config.url.includes('/refresh-token')) {
      console.log(`[API] Success: ${response.config.url}`, response.status);
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const isAuthEndpoint = originalRequest.url.includes('/auth/');
    
    if (!isAuthEndpoint && error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          // ✅ FIXED: Use api instance instead of axios
          const response = await api.post(
            '/api/auth/refresh-token',
            { refreshToken },
            { withCredentials: true }
          );
          
          if (response.data.success) {
            const newToken = response.data.token;
            localStorage.setItem('authToken', newToken);
            api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return api(originalRequest);
          }
        }
      } catch (refreshError) {
        console.error('[API] Token refresh failed:', refreshError);
      }
    }

    // Error handling (unchanged)
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (!isAuthEndpoint) {
            message.destroy();
            message.error('Session expired. Please log in again.');
            localStorage.removeItem('authToken');
            localStorage.removeItem('refreshToken');
            if (!window.location.pathname.includes('/login')) {
              window.location.assign('/login?session_expired=1');
            }
          }
          break;
        case 403:
          message.error('Access denied. Insufficient permissions.');
          break;
        case 429:
          message.warning('Too many requests. Please slow down.');
          break;
        default:
          const errorMessage = error.response.data?.message || 
            `Request failed (${error.response.status})`;
          message.error(errorMessage);
      }
    } else if (error.code === 'ECONNABORTED') {
      message.error('Request timeout. Please try again.');
    } else {
      message.error('Network error. Please check your connection.');
    }

    return Promise.reject(error);
  }
);

export default api;